export const cardsData = [
  {
    title: 'Team members with no 1:1s scheduled',
    subTitle: '',
    value: 1,
    color: '',
  },
  {
    title: 'Team members with no 1:1s in last 30 days',
    subTitle: '',
    value: 2,
    color: '',
  },
  {
    title: 'Average completion',
    subTitle: 'since last month',
    value: '42%',
    count: '15%',
    color: 'warning',
  },
  {
    title: 'Team completion ranking',
    subTitle: 'since last month',
    value: '56%ile',
    count: '15%',
    color: 'success',
  },
];

export const lineChartData = {
  nodes: [
    {
      id: '1',
      name: 'Belonging',
    },
    {
      id: '2',
      name: 'Growth',
    },
    {
      id: '3',
      name: 'Collaboration',
    },
    {
      id: '4',
      name: 'Performance',
    },
    {
      id: '5',
      name: 'Manager Effectiveness',
    },
  ],
  series: [
    {
      id: '1',
      data: [12, 6, 30, 12, 20, 22],
    },
    {
      id: '2',
      data: [10, 9, 5, 6, 3, 10],
    },
    {
      id: '3',
      data: [9, 7, 19, 30, 10, 24],
    },
    {
      id: '4',
      data: [16, 5, 19, 10, 30, 25],
    },
    {
      id: '5',
      data: [16, 8, 19, 10, 10, 26],
    },
  ],
  xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  yaxisRange: {
    start: 0,
    end: 30,
  },
};

export const barChartData = {
  xaxis: ['Helen Mirren', 'Ming Ye', 'George Weber', 'Jay Chandra'],

  series: [
    {
      id: '1',
      data: [12, 23, 30, 20],
    },
    {
      id: '2',
      data: [12, 13, 10, 30],
    },
  ],
  nodes: [
    {
      color: {
        dark: '#B1E39F',
        light: '#B1E39F',
      },
      id: '1',
      name: 'Completed',
    },
    {
      color: {
        dark: '#FFAE99',
        light: '#FFAE99',
      },
      id: '2',
      name: 'Cancelled',
    },
  ],
  yaxisRange: {
    start: 0,
    end: 30,
  },
};
